module.exports = __webpack_public_path__ + "img/gallery-09.e5361733.jpg";